import React from 'react';
import { CheckCircle2, CreditCard, TrendingUp, Shield, Clock, ArrowRight, Calendar } from 'lucide-react';

const StarterTradelinePage = () => {
  const paymentLink = "https://www.thewealthcollection.com/products/the-wealth-starter-bundle?variant=45716073513017";

  return (
    <div className="dark-page">
      {/* Hero Section */}
      <section className="tradelines-hero">
        <div className="tradelines-hero-content">
          <div className="tradelines-badge">STARTER TRADELINE</div>
          <h1 className="display-huge tradelines-title">
            <span className="text-gradient">$3,500</span> Primary Tradeline
          </h1>
          <p className="body-large tradelines-subtitle" style={{ maxWidth: '700px', margin: '0 auto 30px' }}>
            If your credit profile isn't strong enough to get approved, this is the missing piece.
            Our $3,500 Primary Tradeline is designed to help position your credit the right way — 
            not just increase your score, but improve how lenders actually see you.
          </p>
          
          <div className="tradelines-features-row">
            <div className="tradeline-feature-item">
              <CreditCard size={24} />
              <span>$3,500 Limit</span>
            </div>
            <div className="tradeline-feature-item">
              <Clock size={24} />
              <span>2+ Years History</span>
            </div>
            <div className="tradeline-feature-item">
              <Shield size={24} />
              <span>All 3 Bureaus</span>
            </div>
          </div>
        </div>
      </section>

      {/* Buy Now CTA */}
      <section style={{ padding: '40px 7.6923%', textAlign: 'center', background: 'var(--bg-primary)' }}>
        <a 
          href={paymentLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
          style={{ fontSize: '20px', padding: '20px 50px' }}
        >
          Buy Now <ArrowRight size={24} />
        </a>
      </section>

      {/* What This Does Section */}
      <section className="wealth-for-section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="section-header">
          <h2 className="display-medium section-title">What This Does For You</h2>
          <p className="body-medium section-description">
            This isn't just another account… it's strategic.
          </p>
        </div>
        
        <div className="wealth-for-grid" style={{ maxWidth: '800px', margin: '30px auto 0' }}>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Strengthen your overall credit profile</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Improve your utilization</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Increase your approval odds</span>
          </div>
          <div className="wealth-for-item">
            <CheckCircle2 size={20} />
            <span>Look more attractive to lenders</span>
          </div>
        </div>
      </section>

      {/* Tradeline Details */}
      <section className="tradelines-grid-section">
        <div className="section-header">
          <h2 className="display-medium section-title">Tradeline Details</h2>
        </div>
        
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div className="tradeline-card" style={{ borderColor: 'var(--accent-gold)' }}>
            <div className="tradeline-card-header">
              <h3 className="tradeline-card-title" style={{ color: 'var(--accent-gold)' }}>$3,500 Primary Tradeline</h3>
            </div>
            
            <ul className="tradeline-card-features">
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>$3,500 Credit Limit</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>2+ Years Payment History</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Reports as Revolving</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Reports to All 3 Bureaus (Equifax, Experian, TransUnion)</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Reports on the 15th of Every Month</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>14-45 Day Posting Window</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Helps Optimize Credit Utilization</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Positioned for Funding & Approvals</span>
              </li>
            </ul>

            <div className="tradeline-card-footer" style={{ marginTop: '30px' }}>
              <a 
                href={paymentLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary tradeline-buy-btn"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Buy Now <ArrowRight size={18} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Who Is This For */}
      <section className="wealth-for-section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="section-header">
          <h2 className="display-medium section-title">Who Is This For?</h2>
        </div>
        
        <div className="wealth-for-grid" style={{ maxWidth: '800px', margin: '30px auto 0' }}>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>People looking to build or rebuild credit</span>
          </div>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>Those preparing for funding applications</span>
          </div>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>Anyone who needs to improve their approval odds</span>
          </div>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>Clients looking for an affordable entry point</span>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Ready to Strengthen Your Credit?</h2>
          <p className="body-large" style={{ marginBottom: '30px' }}>
            Get started with the $3,500 Primary Tradeline and position yourself for approvals.
          </p>
          <a 
            href={paymentLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ fontSize: '18px', padding: '18px 40px' }}
          >
            Buy Now <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default StarterTradelinePage;
